import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/form-requests/{formRequestId}/deduplicate-list-items']['POST'];

type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const deduplicateListItems = async ({ formRequestId, fieldKey }: Input): Promise<Output> => {
  const data = await noodleApiClient.post(`/form-requests/${formRequestId}/deduplicate-list-items`, { fieldKey });
  return data.data;
};

export default deduplicateListItems;
